import React from 'react';
import cx from 'classnames';
import MoCommonTop from '@src/ui-components/mo-common-top';
import styles from './index.less';

const STAGE_LAYER_MAP = {
  four: { group: 'group9', achieved: 'layer13', unachieved: 'layer14', name: '四人组队奖励' },
  three: { group: 'group10', achieved: 'layer15', unachieved: 'layer16', name: '三人组队奖励' },
  two: { group: 'group11', achieved: 'layer17', unachieved: 'layer18', name: '二人组队奖励' }
};

function isStageAchieved(teamRewardStages, stageKey) {
  const stage = teamRewardStages.find(item => item && item.key === stageKey);
  return Boolean(stage && stage.achieved);
}

function renderStage(teamRewardStages, stageKey) {
  const layer = STAGE_LAYER_MAP[stageKey];
  const achieved = isStageAchieved(teamRewardStages, stageKey);

  return (
    <div className={styles[layer.group]} data-name={layer.name}>
      <div
        className={cx(styles[layer.achieved], achieved ? styles.visibleStateLayer : styles.hiddenStateLayer)}
        data-name="已达成展示态"
        data-stage-key={stageKey}
        data-stage-state="achieved"
        aria-hidden={!achieved}
      />
      <div
        className={cx(styles[layer.unachieved], achieved ? styles.hiddenStateLayer : styles.visibleStateLayer)}
        data-name="未达成展示态"
        data-stage-key={stageKey}
        data-stage-state="unachieved"
        aria-hidden={achieved}
      />
    </div>
  );
}

/* 领取按钮三态（2026-09-10 设计补图）：claim_status 契约 0 不可领 / 1 可领 / 2 已领；
   claimStatus=1 用 available，2 用 collected，其余（0 / 奖励未就绪）统一 notAvailable；
   claiming / 页面操作锁属于可领态的临时锁，经 claimLocked class 的置灰滤镜反馈——
   不用原生 disabled（2026-09-17 用户决策：置灰仍可点击，点击送达 Store Toast 不可领原因） */
const CLAIM_STATE_LAYERS = {
  claimable: { className: 'claimableLayer', name: '领取奖励-可领取态' },
  collected: { className: 'collectedLayer', name: '领取奖励-已领取态' },
  notAvailable: { className: 'notAvailableLayer', name: '领取奖励-未达成态' }
};

function resolveClaimState(posterReward) {
  if (posterReward && posterReward.claimStatus === 2) {
    return 'collected';
  }

  return posterReward && posterReward.claimStatus === 1 ? 'claimable' : 'notAvailable';
}

const MoBackpack = ({ teamRewardStages = [], posterReward = {}, claimDisabled = false, claiming = false, onClaim, children, className }) => {
  const claimLocked = claimDisabled || claiming;
  const claimState = resolveClaimState(posterReward);
  // 置灰只承载视觉，拦截决策上移页面 Store：点击始终送达，由 Store 按原因 Toast（与 role-binding 同模式）
  const handleClaim = () => {
    if (onClaim) {
      onClaim();
    }
  };

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.layer1} data-name="我的背包-背景" />
      <div className={styles.group1} data-name="通用组件-主体内容">
        <div className={styles.group6} data-name="公测福利入口区">
          <div className={styles.layer8} data-name="公测福利入口 - 标题" />
          <div className={styles.layer9} data-name="二维码 - 微信公众号" />
          <div className={styles.layer10} data-name="二维码 - 福利管家" />
          <div className={styles.layer11} data-name="微信公众号">
            微信公众号
          </div>
          <div className={styles.layer12} data-name="福利管家">
            福利管家
          </div>
        </div>

        <div className={styles.group7} data-name="成团奖励区">
          <div className={styles.group8} data-name="成团奖励-奖励展示">
            {renderStage(teamRewardStages, 'four')}
            {renderStage(teamRewardStages, 'three')}
            {renderStage(teamRewardStages, 'two')}
          </div>
          <div className={styles.layer19} data-name="成团奖励-标题" />
        </div>

        <div className={styles.group12} data-name="生成海报奖励区">
          <button
            type="button"
            className={cx(styles.layer20, styles.claimButton, claimLocked && styles.claimLocked)}
            data-name="领取奖励-按钮"
            data-reward-status={posterReward.claimStatus}
            data-claim-state={claimState}
            aria-disabled={claimLocked}
            aria-busy={claiming}
            onClick={handleClaim}
          >
            {/* 三态互斥层与 layer20 同几何（320×83 @0,0），运行时显隐；layer20 背景由态层完全覆盖，仅保留 PSD 基线 */}
            {Object.keys(CLAIM_STATE_LAYERS).map(stateKey => {
              const layer = CLAIM_STATE_LAYERS[stateKey];
              return (
                <div
                  key={stateKey}
                  className={cx(styles[layer.className], styles.claimStateLayer, claimState === stateKey ? styles.visibleStateLayer : styles.hiddenStateLayer)}
                  data-name={layer.name}
                  data-claim-layer={stateKey}
                  aria-hidden={claimState !== stateKey}
                />
              );
            })}
          </button>
          <div className={styles.group13} data-name="奖励展示区（纯展示）">
            <div className={styles.layer21} data-name="奖励4" />
            <div className={styles.layer22} data-name="奖励3" />
            <div className={styles.layer23} data-name="奖励2" />
            <div className={styles.layer24} data-name="奖励1" />
          </div>
          <div className={styles.layer25} data-name="海报分享奖励-标题" />
        </div>
      </div>

      <MoCommonTop />
      <div className={styles.layer27} data-name="我的背包 - 标题" />
      {children}
    </div>
  );
};

export default MoBackpack;
